import { render, staticRenderFns } from "./InspectionStep4.vue?vue&type=template&id=5f05bd79&"
import script from "./InspectionStep4.vue?vue&type=script&lang=js&"
export * from "./InspectionStep4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports